var $ = jQuery;

$(document).on('ready', function(){
    $(document).on('click', '.pay-btn', function(e) {
        e.stopImmediatePropagation();
        // payment-card renders one instance per breakpoint (submit-mobile /
        // submit-desktop), so target the visible one or we drive the wrong
        // Stripe Elements instance.
        $('[id^="submit-"]:visible').first().trigger('click');
    })
})